import { RecipeStepForm, RecipeStepFormProps } from './RecipeStepForm';

export const RecipeStepFormCard = (props: RecipeStepFormProps) => {
  return (
    <div className="c-recipe-step-from-card pb-4 md:pb-25">
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <RecipeStepForm
          {...props}
        />
      </div>
    </div>
  );
};
